{
  "skipToContent": "Vai al contenuto",
  "reel": {
    "hint": "Scorri per il passo successivo ↓",
    "prev": "← Prec",
    "next": "Succ →",
    "position": "Passo {{index}} di {{count}}"
  },
  "cta": {
    "eyebrow": "Il prossimo passo",
    "defaultTitle": "Pronto a iniziare o vuoi più informazioni?",
    "explorer": "Prova DEC Explorer",
    "contact": "Contatta i nostri esperti",
    "contactShort": "Contattaci",
    "howItWorks": "Come funziona"
  },
  "eyebrow": {
    "successStory": "Caso di successo",
    "caseReal": "Caso reale",
    "persona": "Per chi è"
  },
  "blog": {
    "heading": "Notizie e approfondimenti",
    "sub": "Visita il nostro blog per scoprire articoli dedicati a energia rinnovabile, sostenibilità e le ultime notizie di settore.",
    "allLink": "Tutti gli articoli"
  },
  "stats": [
    {
      "prefix": "fino a",
      "target": 25,
      "suffix": "%",
      "label": "di risparmio sui tuoi costi energetici"
    },
    {
      "prefix": "fino a",
      "target": 20,
      "suffix": "k €",
      "label": "di aumento EBITDA per ogni GWh"
    },
    {
      "target": 15,
      "suffix": "min",
      "label": "granularità del dato di produzione, in tempo reale"
    },
    {
      "target": 100,
      "suffix": "%",
      "label": "produzione tracciata e certificata dal GSE"
    }
  ],
  "nav": {
    "companies": "Per aziende",
    "producers": "Per produttori",
    "resources": "Risorse",
    "solutions": "Soluzioni",
    "whoWeServe": "Chi serviamo",
    "howItWorks": "Come funziona",
    "aboutUs": "Chi siamo",
    "home": "Home",
    "login": "Accedi",
    "contact": "Contattaci",
    "switchToProducers": "Sei un produttore?",
    "switchToCompanies": "Sei un'azienda?",
    "switchTitle": "Passa all'altra versione del sito",
    "decExplorer": "DEC Explorer",
    "decExplorerDesc": "Il numero sui tuoi consumi",
    "faq": "FAQ",
    "faqDesc": "Le domande che ci fanno più spesso",
    "blog": "DEC insights",
    "blogDesc": "Scopri gli ultimi articoli e le notizie più recenti",
    "solutionLabels": {
      "riduzione-prevedibile": "Riduzione prevedibile dei costi energetici",
      "ebitda": "Migliora la tua redditività operativa",
      "conformita": "Conformità future-proof e profittevole",
      "copertura-naturale": "Riduci la volatilità dei costi energetici",
      "impatto": "Transizione energetica raccontabile"
    },
    "solutionCategories": {
      "riduzione-prevedibile": "Riduci costi",
      "ebitda": "EBITDA",
      "conformita": "ESG compliance",
      "copertura-naturale": "Hedging",
      "impatto": "Impatto"
    },
    "roleLabels": {
      "ipp-light": "Piccolo produttore",
      "ipp": "IPP",
      "utility": "Utility"
    },
    "roleDescs": {
      "ipp-light": "Impianti piccoli e medi",
      "ipp": "Portafogli in crescita",
      "utility": "Cassa senza toccare la PFN"
    },
    "mainLabel": "Navigazione principale",
    "closeMenu": "Chiudi menu",
    "openMenu": "Apri menu",
    "companiesShort": "Aziende",
    "producersShort": "Produttori",
    "investors": "Per investitori",
    "investorsShort": "Investitori",
    "footer": {
      "description": "La transizione energetica\nresa profittevole.",
      "rights": "Tutti i diritti riservati.",
      "tagline": "Contrattualizziamo a distanza impianti fotovoltaici attivi, per aziende e produttori.",
      "disclaimer": "DEC Energy SA non fornisce energia elettrica.",
      "colCompanies": "Aziende",
      "colProducers": "Produttori",
      "colResources": "Risorse",
      "overview": "Panoramica",
      "howItWorks": "Come funziona",
      "aboutUs": "Chi siamo",
      "contacts": "Contatti",
      "privacy": "Privacy policy"
    }
  },
  "notFound": {
    "eyebrow": "Errore 404",
    "title": "Questa pagina",
    "highlight": "non esiste",
    "subtitle": "Il link potrebbe essere vecchio, o l'indirizzo digitato male. Da qui puoi tornare all'inizio o scriverci.",
    "primaryLabel": "Torna alla home",
    "secondaryLabel": "Contattaci"
  },
  "fields": {
    "surface_type": {
      "roof": "Tetto",
      "land (agricultural)": "Terreno\n (Agricolo)",
      "land (industrial)": "Terreno \n(Industriale)"
    }
  },
  "form": {
    "error": "Qualcosa è andato storto. Riprova tra poco."
  },
  "quotes": {
    "label": "Citazioni"
  },
  "calendly": {
    "cookie": "Per utilizzare il calendario di prenotazione è necessario accettare i cookie di terze parti.\n In alternativa puoi utilizzare il nostro modulo di contatto.",
    "contact-form": "Modulo di contatto",
    "contact": "Per qualsiasi domanda, contattaci a ",
    "accept-cookies": "Accetta i cookie",
    "booking": {
      "meet-title": "Incontra DEC Energy",
      "tz-cet": "Ora dell'Europa centrale ({{time}})",
      "select-date-time": "Seleziona data e orario",
      "timezone": "Fuso orario",
      "next": "Avanti",
      "enter-details": "Inserisci i dettagli",
      "confirmed": "Appuntamento confermato!",
      "confirmation-message": "Un invito è stato inviato a {{email}}.",
      "join-meet": "Partecipa alla chiamata Google Meet",
      "schedule-another": "Prenota un altro appuntamento",
      "prev-month": "Mese precedente",
      "next-month": "Mese successivo",
      "meeting-duration": "Durata dell'incontro",
      "duration-heading": "Durata dell'incontro",
      "duration-15": "approfondimento del modello DEC Energy",
      "duration-45": "analisi gratuita dei risparmi personalizzata e approfondimento del modello DEC Energy",
      "no-slots": "Nessun orario disponibile per questa durata.",
      "field-required": "Campo obbligatorio",
      "email-invalid": "Inserisci un indirizzo email valido",
      "phone-invalid": "Inserisci un numero di telefono valido",
      "selected-time": "Orario selezionato",
      "submitting": "Prenotazione in corso…",
      "submitting-hint": "Stiamo creando l'appuntamento e il link Google Meet, potrebbe volerci qualche secondo.",
      "select-duration": "Seleziona la durata",
      "form": {
        "fields": {
          "guest_name": {
            "label": "Nome completo"
          },
          "guest_email": {
            "label": "Indirizzo email"
          },
          "company_name": {
            "label": "Nome azienda"
          },
          "phone_number": {
            "label": "Numero di telefono"
          },
          "notes": {
            "label": "Note"
          }
        },
        "submit": "Prenota appuntamento",
        "back": "Modifica data e orario"
      }
    }
  },
  "accept-banner": {
    "header": "Consenso cookie",
    "message": "Cliccando su accetta acconsenti all'uso dei cookie per migliorare la tua esperienza e analizzare il traffico del sito. Per maggiori dettagli, consulta la nostra",
    "privacy-policy-link": "informativa sulla privacy.",
    "accept": "Accetta",
    "reject": "Rifiuta"
  },
  "company": {
    "next-steps": {
      "title": "<h2>Sei pronto per iniziare o hai bisogno di più informazioni?</h2>",
      "description": "Seleziona come procedere:",
      "tag": "IL PROSSIMO PASSO",
      "calc": "Vai a DEC explorer",
      "contact": "Contatta i nostri esperti",
      "contact-us": "Per qualsiasi domanda, contattaci a"
    }
  },
  "producer": {
    "next-steps": {
      "title": "<h2>Sei pronto per iniziare \no hai bisogno di più informazioni?</h2>",
      "contact": "Contatta i nostri esperti",
      "contact-us": "Per qualsiasi domanda, contattaci a"
    }
  },
  "byAuthor": "di {{author}}",
  "waterfall": {
    "today": "Oggi",
    "result": "Risultato"
  }
}
